import React from 'react'
import DOMPurify from 'dompurify';
import getYear from "../../../../../utils/getYear";

import './PanelMethods.scss';

const PanelMethods = ({ methods }) => {
    return (
        <>
            {getYear() < 2025 && 
                <div className="panel-methods" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(methods, { ADD_ATTR: ['target'] }) }}>
                </div>
            }
        </>
    )
}

export default PanelMethods